import RoundedButtonLink from '../../components/buttons/RoundedButtonLink'
import createAccountSuccess from '../../assets/create-account-success.png'
import strings from '../../res/strings'

const SuccessView = (props) => {
    return (
        <div className='flex flex-col flex-1 items-center justify-center'>
            <img className='h-[20.188rem] w-[26.563rem]' src={createAccountSuccess} alt='Imagem Sucesso'/>
            <p className='font-montserrat text-center mt-11'>{props.message}</p>
            
            <div className='mt-11 w-[18.75rem]'>
                <RoundedButtonLink 
                    path='/'
                    text={strings.goToLogin}
                    height={48}
                    bgColor='#007EB4'
                    flex={true}
                />
            </div>
        </div>
    )
}

export default SuccessView